export default function () {
  if (this.modelID)
    this.$http
      .get(this.pageSettings.webService + '/' + this.$route.params.id)
      .then((res) => {
        this.input = res.data.data
        if (typeof this.afterGetData != 'undefined')
          this.afterGetData(res)
      })
      .catch((err) => {
        this.alertNotice({
          type: 'danger',
          title: 'Failed',
          content: err.data,
        })
      })
      .finally(this.processing = false)
}